var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearchFilterApply(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.895,10.808c-.812,6.472,3.573,12.727,9.879,14.267,8.996,2.197,17.338-5.114,16.332-14.267h7.744c.066,0,.461.209.551.274.623.45.769,1.292.398,1.957l-15.931,18.89-.047,1.328-11.686,5.863v-7.284L2.239,13.094c-.419-.664-.28-1.549.361-2.012.089-.065.485-.274.551-.274h7.744Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.065,2.04c8.298-.704,13.959,8.133,9.806,15.392s-15.014,6.609-18.298-1.094c-2.726-6.394,1.559-13.71,8.492-14.298ZM27.266,8.066l-4.424,4.293-2.174-2.002-1.976,2.042,3.297,3.307c.729.446,1.475.248,2.06-.314l5.261-5.283-2.043-2.042Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.866,36.554v3.894c0,.381-.643.883-.947,1.069-2.734,1.673-6.175,2.903-9.018,4.452-.607.135-1.313-.182-1.6-.738-.223-.431-.231-2.064-.17-2.589.015-.132.009-.241.152-.306l11.584-5.782Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchFilterApply);
export default __webpack_public_path__ + "static/media/icon-search-filter-apply.aa0a10f4e02c0593eeb8113773f985ea.svg";
export { ForwardRef as ReactComponent };